import { createSelector } from "reselect";

const tdsp = () => (state) => state.tdsp;

const selectTDSPContainer = () => {
    return createSelector(tdsp(), (data) => data)
}

export default selectTDSPContainer;